import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class UploadProgressService {

    private progressEvents = {};

    private totalBytesToUpload = new Subject<number>();
    private remainingBytesToUpload = new Subject<number>();
    percentCompleted: Observable<number>;

    constructor() {
        this.percentCompleted = Observable.zip(
            this.totalBytesToUpload,
            this.remainingBytesToUpload,
            (tot: number, rem: number) => parseInt((((tot - rem) / tot) * 100).toFixed(0), 10)
        );
    }


    nextProgressEvent(xhrId: number, event: ProgressEvent) {
        this.progressEvents[xhrId] = event;

        let progressEventsValues = this.getProgressEventsValues();
        let tot = this.computeTotalBytesToUpload(progressEventsValues);
        let loadedBytes = this.computeLoadedBytes(progressEventsValues);
        let rem = tot - loadedBytes;
        this.totalBytesToUpload.next(tot);
        this.remainingBytesToUpload.next(rem);

        if (this.allBytesSent(progressEventsValues)) {
            this.progressEvents = [];
        }
    }

    private computeTotalBytesToUpload(progressEventsValues: Array<ProgressEvent>): number {
        return progressEventsValues.map(pe => pe.total).reduce((acc, curr) => acc + curr);
    }

    private computeLoadedBytes(progressEventsValues: Array<ProgressEvent>): number {
        return progressEventsValues.map(pe => pe.loaded).reduce((acc, curr) => acc + curr);
    }

    private allBytesSent(progressEventsValues: Array<ProgressEvent>): boolean {
        return progressEventsValues.map(pe => pe.loaded === pe.total).reduce((acc, curr) => acc && curr);
    }

    private getProgressEventsValues(): Array<ProgressEvent> {
        let progressEventsValues = new Array<ProgressEvent>();
        for (let i in this.progressEvents) {
            if (this.progressEvents.hasOwnProperty(i)) {
                progressEventsValues.push(this.progressEvents[i]);
            }
        }
        return progressEventsValues;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/upload/upload-progress.service.ts